import axios from "axios";

const axiosInstance = ({ requiresAuth = false } = {}) => {
    // const url = "http://127.0.0.1:8001/api/";
    const url = "https://api-sandbox.cleandata.ch/api/";
    const options = {
        // baseURL: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/',
        baseURL: url,
        headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
        },
    };

    if (requiresAuth) {
        const token = localStorage.getItem("token");
        if (token) {
            options.headers.Authorization = `Bearer ${token}`;
        }
    }

    return axios.create(options);
};

export default axiosInstance;
 